
import pricingHandler from '../pricingHandler'

const jsonLdHelper = {
    applyOfferFromPriceAndStock(stockPriceData) {
        if (stockPriceData.price > 0) {
            const currency = window.Alpine.store('currency')
            // https:// schema.org/Offer
            this.completeJson.offers = {
                '@type': 'Offer',
                availability: 'https://schema.org/InStock',
                price: pricingHandler().isUKGoogleShopping() ? stockPriceData.price_minimum_quantity_taxed : stockPriceData.price_minimum_quantity,
                currency: currency.iso_code,
                priceCurrency: currency.iso_code,
                priceValidUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                url: this.completeJson.url,
            }
        }
    },
    applyBrandFromPriceAndStock(stockPriceData) {
        this.completeJson.brand = {
            '@type': 'Brand',
            name: stockPriceData.manufacturer_name,
        }
    },
    applyRatingFromPriceAndStock(stockPriceData) {
        if (stockPriceData.total_rating_count !== null) {
            this.completeJson.aggregateRating = {
                '@type': 'AggregateRating',
                ratingValue: stockPriceData.total_average_rating,
                reviewCount: stockPriceData.total_rating_count,
            }
        }
    },
    buildMarkup() {
        // only products with offers or ratings can generate json , missing both values is considered error in rch snippet checker
        if (Object.prototype.hasOwnProperty.call(this.completeJson, 'aggregateRating') || Object.prototype.hasOwnProperty.call(this.completeJson, 'offers')) {
            const generatedJsonLd = JSON.stringify(this.completeJson)
            const s = document.createElement('script')
            s.type = 'application/ld+json'
            s.innerHTML = generatedJsonLd
            document.body.appendChild(s)
        }
    },
}

export default jsonLdHelper
